const ActionTypes = {
  ADD_SELECTED_VARIABLES: '[Variables] Add Selected Variables',
  REMOVE_SELECTED_VARIABLES: '[Variables] Remove Selected Variables',

  SAVE_VARIABLES_PRESET: '[Variables] Save Variables Preset',
  SAVE_VARIABLES_PRESET_SUCCESS: '[Variables] Save Variables Preset Success',
  SAVE_VARIABLES_PRESET_FAIL: '[Variables] Save Variables Preset Fail',

}

export class AddSelectedVariables {
  static type = ActionTypes.ADD_SELECTED_VARIABLES;

  constructor(public payload: string[], public replace: boolean) {}
}

export class RemoveSelectedVariables {
  static type = ActionTypes.REMOVE_SELECTED_VARIABLES;

  constructor(public payload: string[]) {}
}

export class ClearSelectedVariables {
  static type = '[Variables] Clear Selected Variables';
}

export class SaveVariablesPreset {
  static type = ActionTypes.SAVE_VARIABLES_PRESET;

  constructor(public name: string, public variables:string[]) {}
}

export class SaveVariablesPresetSuccess {
  static type = ActionTypes.SAVE_VARIABLES_PRESET_SUCCESS;

  constructor(public payload: any) {}
}

export class SaveVariablesPresetFail {
  static type = ActionTypes.SAVE_VARIABLES_PRESET_FAIL;
}
